import { render, staticRenderFns } from "./Campaign.vue?vue&type=template&id=a81f6682&scoped=true"
var script = {}
import style0 from "./Campaign.vue?vue&type=style&index=0&id=a81f6682&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81f6682",
  null
  
)

export default component.exports